export default __webpack_public_path__ + "static/media/team3.32408900.png";